import { useQuery } from '@tanstack/react-query';
import { TileCard, PageHeader, EmpButton, EmpSpace } from '@empowernow/ui';
import { useNavigate } from 'react-router-dom';
import { workflowApi } from '../core/services/api';

export default function WorkflowsList({ testItems }: { testItems?: any[] } = {}) {
  const navigate = useNavigate();
  const { data, isLoading, error } = useQuery({
    queryKey: ['workflows'],
    queryFn: () => workflowApi.listWorkflows(),
    enabled: !testItems,
  });

  const raw = (data as any)?.data ?? (data as any);
  const items = testItems ?? (raw as any)?.items ?? raw ?? [];

  return (
    <>
      <PageHeader title="Workflows" />
      {isLoading && <div className="glass-card p-4" role="status" aria-live="polite">Loading workflows…</div>}
      {(!isLoading && error) && <div className="glass-card p-4" role="alert">Failed to load workflows</div>}
      {!isLoading && !error && (
        <div className="emp-grid-tiles">
          {Array.isArray(items) && items.map((wf: any) => (
            <TileCard key={wf.id} theme="auto" elevation={1} padding={16}>
              <div className="emp-tile">
                <div className="emp-tile-title">{wf.name || 'Workflow'}</div>
                <EmpSpace align="center" style={{ width: '100%', justifyContent: 'space-between' }}>
                  <span>{wf.description || 'No description'}</span>
                  <EmpButton type="link" onClick={() => navigate(`/run/workflow/${wf.id}`)}>Open</EmpButton>
                </EmpSpace>
              </div>
            </TileCard>
          ))}
        </div>
      )}
    </>
  );
}


